import React, { Component } from "react";
import Navbar from "./Navbar/Navbar";
import "./Header.css";

class header extends Component {
    render() {
        return (
            <header className="intro">
                <Navbar />
                <div className="container-fluid py-30">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col text-light text-center">
                            <h5
                                className="fw-bold text-uppercase"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: "1.5rem",
                                    color: "#cc005f",
                                }}
                            >
                                Hello, World.
                            </h5>
                            <h1 style={{ fontSize: "6rem" }}>
                                I'm Ferdous Hasan.
                            </h1>
                            <p
                                className="lead fw-bold"
                                style={{ fontSize: "1.5rem" }}
                            >
                                <span>A MERN Stack Developer</span>
                            </p>
                            <a
                                href="#about"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: "0.8rem",
                                    padding: "1rem 5rem",
                                    border: "3px solid #FFFFFF",
                                }}
                                className="btn btn-lg text-light text-capitalize rounded-0 my-3"
                            >
                                more about me
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default header;
